import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { BackEndService } from "src/app/services/back-end.service";

@Component({
  selector: "app-password",
  templateUrl: "./password.component.html",
  styleUrls: ["./password.component.scss"]
})
export class PasswordComponent implements OnInit {

  public formPass: FormGroup;
  public objPass = {
    nueva_contrasena: "",
    confirmar_contrasena: ""
  };

  constructor(
    private auth: AuthService,
    private backend: BackEndService,
    private router: Router
  ) {
    this.formPass = new FormGroup({
      nueva_contrasena: new FormControl("", [
        Validators.required,
        Validators.minLength(4)
      ]),
      confirmar_contrasena: new FormControl("", [
        Validators.required,
        Validators.minLength(4)
      ])
    });
    this.formPass.controls["confirmar_contrasena"].setValidators([
      Validators.required,
      this.notEqual.bind(this.formPass)
    ]);

    this.formPass.setValue(this.objPass);
  }

  ngOnInit() {
    this.auth.hide();
  }

  notEqual(control: FormControl): { [s: string]: boolean } {
    const formpass: any = this;
    if (control.value !== formpass.controls["nueva_contrasena"].value) {
      return {
        noiguales: true
      };
    }
    return null;
  }

  confirmPassword(form: NgForm) {
    if (form.invalid) {
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      type: "info",
      text: "Espere por favor..."
    });
    Swal.showLoading();

    this.backend.changePass(this.formPass.value).subscribe(
      (resp: any) => {
        (window as any).gtag("event", "login", {
          event_category: "actualizar_contrasena",
          event_label: ""
        });

        Swal.close();

        this.router.navigateByUrl("/login");
      },
      err => {
        console.log("error", err);
        Swal.fire({
          type: "error",
          title: "Error al cambiar contraseña",
          text: "Error de contraseña"
        });
      }
    );
  }

}
